import { useEffect } from "react"
import { Icon, palette, Tooltip } from "@callcenter/design-system"
import { useUnit } from "effector-react"
import { t } from "i18next"
import { $userService } from "@callcenter/effector-services"
import { SoftphoneService } from "@callcenter/services"

import styles from "./call-button.module.pcss"

export const CallButton = () => {
  const isOmniChannelWorkspaceEnabled = useUnit($userService.$permissions).has("omnichannel_workspace_enabled")
  const isLoading = useUnit($userService.$isPermissionsLoading)

  useEffect(() => {
    SoftphoneService.autoOpenSoftphoneWindow()
  }, [])

  return (
    <Tooltip
      isHighestLayer
      title={
        isOmniChannelWorkspaceEnabled && !isLoading
          ? t("component_component_agentWorkspace_agentWorkspaceLabel")
          : t("component_component_agentPanel_agentPanelLabel")
      }
    >
      <button type="button" onClick={SoftphoneService.openSoftphoneWindow} className={styles.callButton}>
        <Icon icon={Icon.icons.system.s.channels.voice} size={18} color={palette.blue6} />
      </button>
    </Tooltip>
  )
}
